module.exports = __webpack_public_path__ + "img/vehicleverde.3bc3bb3b.png";